import { faFileExcel, faFilePdf, faFileWord } from '@fortawesome/free-regular-svg-icons'
import { faChartArea, faDownLeftAndUpRightToCenter, faMapLocationDot, faPaperclip, faTable, faUserTie } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  AccessAlarm,
  AccountTree,
  AccountBox,
  AddBoxRounded,
  AddCircleOutline,
  AddCircleOutlined,
  AddLocationAltOutlined,
  AddOutlined,
  AdminPanelSettingsOutlined,
  AppRegistration,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowForwardIos,
  ArrowRight,
  BarChartOutlined,
  Block,
  Cached,
  CancelScheduleSendOutlined,
  Cancel,
  CancelOutlined,
  CheckCircle,
  CheckBox,
  DisabledByDefault,
  CheckCircleOutlineOutlined,
  Check as CheckSimple,
  Close,
  ContentCopy,
  CorporateFare,
  DeleteOutline,
  DescriptionOutlined,
  DragIndicator,
  EditOutlined,
  Email,
  EmailOutlined,
  Stop,
  TimerOutlined,
  PendingActionsOutlined,
  FileUpload,
  FormatColorFill,
  QuestionMark,
  ErrorOutline,
  PriorityHigh,
  ErrorOutlineOutlined,
  EventAvailable,
  EventNoteOutlined,
  ExpandMore,
  FaceOutlined,
  FileDownloadOutlined,
  FilterAlt,
  FilterAltOff,
  Folder,
  FormatListBulleted,
  ForwardToInbox,
  FullscreenExit,
  CloseFullscreen,
  HighlightOff,
  HomeOutlined,
  ImportExport,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  LocationOn,
  ManageAccounts,
  Menu,
  MoreHoriz,
  MoreVert,
  NotificationsOutlined,
  NotificationsRounded,
  NotInterested,
  OpenInFull,
  PeopleAltOutlined,
  PermContactCalendar,
  PersonOutline,
  Person,
  PestControl,
  Phone,
  PhoneOutlined,
  PieChart,
  PostAdd,
  PlagiarismOutlined,
  Remove,
  Search,
  SendOutlined,
  SettingsOutlined,
  Check as SimpleCheeck,
  Source,
  Store,
  Timeline,
  TouchAppOutlined,
  TuneOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
  Warning,
  WarningAmber,
  WatchLater,
  Shield,
  Build,
  Chat,
  QuestionAnswer,
  WatchLaterOutlined,
  InfoOutlined,
  KeyboardDoubleArrowDownOutlined,
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
  KeyboardDoubleArrowUpOutlined,
  MoreRounded,
  LaunchOutlined,
  UploadFileRounded,
  SwapHoriz,
  PinDropSharp
} from '@mui/icons-material'
import Check from './components/check'
import ReplyIcon from '@mui/icons-material/Reply'

const generalIconsObject = {
  touch: <TouchAppOutlined />,
  forbidden: <NotInterested />,
  pie: <PieChart />,
  location: <LocationOn />,
  tracking: <PendingActionsOutlined/>,
  info: <ErrorOutlineOutlined />,
  priorityHigh: <PriorityHigh />,
  email: <Email />,
  emailOutlined: <EmailOutlined />,
  clock: <AccessAlarm />,
  phone: <Phone />,
  pinDrop: <PinDropSharp />,
  phoneOutlined: <PhoneOutlined />,
  watch: <WatchLater />,
  tree: <AccountTree />,
  timer: <TimerOutlined />,
  person: <PersonOutline />,
  personFilled: <Person />,
  userAccount: <AccountBox />,
  checkBox: <CheckBox />,
  disabledDefault: <DisabledByDefault />,
  moreHoriz: <MoreHoriz />,
  moreVert: <MoreVert />,
  tune: <TuneOutlined />,
  source: <Source />,
  send: <SendOutlined />,
  drag: <DragIndicator />,
  fullScreenExit: <FullscreenExit />,
  closeFullScren: <CloseFullscreen/>,
  fullScreenOpen: <OpenInFull />,
  generatePdf: <i className="fa fa-file"></i>,
  pdf: <FontAwesomeIcon icon={faFilePdf} />,
  csv: <FontAwesomeIcon icon={faFileExcel} />,
  word: <FontAwesomeIcon icon={faFileWord} />,
  table: <FontAwesomeIcon icon={faTable} size="sm" />,
  accountTie: <FontAwesomeIcon icon={faUserTie} size="sm" />,
  map: <FontAwesomeIcon icon={faMapLocationDot} size="sm" vertAdvY={0} />,
  bug: <PestControl />,
  warning: <WarningAmber />,
  warningFull: <Warning />,
  clip: <FontAwesomeIcon icon={faPaperclip} rotation={270} size="sm" />,
  chart: <FontAwesomeIcon icon={faChartArea} />,
  shrink: <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} size="sm" />,
  schedule: <EventAvailable />,
  error: <ErrorOutline />,
  paint: <FormatColorFill />,
  download: <FileDownloadOutlined />,
  upload: <FileUpload />,
  stop: <Stop />,
  block: <Block />,
  visibility: <VisibilityOutlined />,
  store: <Store />,
  company: <CorporateFare />,
  admin: <AdminPanelSettingsOutlined />,
  folder: <Folder />,
  check: <CheckCircle />,
  delete: <DeleteOutline />,
  expand: <ExpandMore />,
  copy: <ContentCopy />,
  close: <HighlightOff />,
  edit: <EditOutlined />,
  menu: <Menu />,
  clean: <FilterAltOff />,
  add: <AddCircleOutlined />,
  refresh: <Cached />,
  search: <Search />,
  bell: <NotificationsOutlined />,
  home: <HomeOutlined />,
  paper: <DescriptionOutlined />,
  user: <PeopleAltOutlined />,
  calendar: <EventNoteOutlined />,
  setting: <SettingsOutlined />,
  filter: <FilterAlt />,
  order: <AppRegistration />,
  upDown: <ImportExport />,
  postAdd: <PostAdd />,
  list: <FormatListBulleted />,
  timeline: <Timeline />,
  'uploadFile': <UploadFileRounded />,
  'swapHoriz' : <SwapHoriz />,
  'check-simple': <CheckSimple />,
  'info-outlined': <InfoOutlined/>,
  'schedule-user': <PermContactCalendar />,
  'check-status': <Check />,
  'bell-rounded': <NotificationsRounded />,
  'action-plan': <QuestionMark />,
  'send-email': <ForwardToInbox />,
  'manage-account': <ManageAccounts />,
  'arrow-r': <KeyboardArrowRight />,
  'arrow-l': <KeyboardArrowLeft />,
  'arrow-double-r': <KeyboardDoubleArrowRight />,
  'arrow-double-l': <KeyboardDoubleArrowLeft />,
  'visibility-off': <VisibilityOffOutlined />,
  'add-rounded': <AddBoxRounded />,
  'arrow-right-simple': <ArrowForwardIos />,
  'arrow-right': <ArrowForward />,
  'arrow-right-fill': <ArrowRight />,
  'arrow-left-fill': <ArrowBack />,
  'simple-close': <Close />,
  'horizontal-line': <Remove />,
  'arrow-down': <ArrowDropDown />,
  'arrow-up': <ArrowDropUp />,
  'man-face': <FaceOutlined />,
  'simple-check': <SimpleCheeck />,
  'bar-chart': <BarChartOutlined />,
  'add-outline': <AddCircleOutline />,
  'cancel-message': <CancelScheduleSendOutlined />,
  'cancel-filled': <Cancel />,
  'cancel': <CancelOutlined />,
  'add-outlined': <AddOutlined />,
  'check-outlined': <CheckCircleOutlineOutlined />,
  'point-in-map': <AddLocationAltOutlined />,
  'guard': <Shield />,
  'corrective': <Build />,
  'Chat': <Chat />,
  'QuestionAnswer': <QuestionAnswer />,
  'Watch': <WatchLaterOutlined />,
  'view-more': <KeyboardDoubleArrowDownOutlined />,
  'view-less': <KeyboardDoubleArrowUpOutlined />,
  'arrow-down-simple': <KeyboardArrowDownOutlined />,
  'arrow-up-simple': <KeyboardArrowUpOutlined />,
  'more-tag': <MoreRounded/>,
  'open-in-new-tab': <LaunchOutlined />,
  'search-file': <PlagiarismOutlined />,
  'reply': <ReplyIcon />,
}

export type IconName = keyof typeof generalIconsObject
export const icons = (name: IconName) => generalIconsObject[name]
